import { generarReportePdf, getDownloadFileName } from "./engine/reportEngine";
import { getReportDefinition } from "./engine/reportRegistry";

export { generarReportePdf, getReportDefinition, getDownloadFileName };

/**
 * Adaptador compatible con la interfaz existente de PdfPreview
 */
export const getReportBuilder = (reportName) => {
  if (!reportName) return null;
  const def = getReportDefinition(reportName);
  if (!def) return null;
  return ({ data, meta }) => generarReportePdf({ reportName, data, meta });
};
